import { activateExperiment } from './';

const ACTIVE_EXPERIMENT_KEYS = [
  'EXP_WBRT_2737_HUB_REMOVE_APPLE_GOOGLE_PAY',
  'EXP_WBRT_4995_HUB_REMOVE_PAYPAL',
  'EXP_WBRT_3788_QUIZ_TAKER_SET_ONBOARDING',
  'EXP_WBRT_3982_HUB_APP_AUTO_LOGIN',
];

export const activateExperiments = () => {
  ACTIVE_EXPERIMENT_KEYS.forEach(activateExperiment);
};
